document.addEventListener('DOMContentLoaded', function () {
    // Function to format numbers with commas in review count
    function formatNumber() {
      document.querySelectorAll('.yotpo-sr-bottom-line-text').forEach((el) => {
        // Match the text pattern for review count (e.g., "(123 Reviews)")
        const match = el.textContent.match(/\((\d+)\sReviews\)/);
    
        if (match) {
          // Format the number with commas and update the text
          el.textContent = `(${Number(match[1]).toLocaleString()} Reviews)`;
        }
      });
    }
    
    // Debounce function to limit the rate of function calls
    const debounce = (func, delay) => {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, delay);
      };
    };
    
    // MutationObserver with debounced formatNumber function
    const observer = new MutationObserver(debounce(formatNumber, 100));
    
    // Select the parent element to observe (it contains the review elements)
    const targetNode = document.querySelector('.zb-main-product');
    
    if (targetNode) {
      // Start observing the target node for changes in its child elements
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      });
    }
    
    // Call formatNumber initially to handle existing content on page load
    formatNumber();
});
